'use client';

import dynamic from 'next/dynamic';
import { AppNextLink } from '@/features/app-next-link';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { useCartReturnUrl } from '@/app/(order)/cart/_utils/use-cart-return-url';
import { OrderPagesURL } from '@/app/(order)/types';
import CartCounterButton from '@/app/(pdp)/_components/buttons/add-to-cart-button/cart-counter-button';
import Logo from './logo';
import MobileHeader from './mobile-header';
import UserSkeleton from './user-skeleton';
import { SearchDesktop } from '../search';
const UserProfile = dynamic(() => import('./user-profile'), {
  ssr: false,
  loading: () => <UserSkeleton />
});
function MainBar() {
  const {
    isMobile
  } = useMobileDetect();
  const {
    setCartBackReturnUrl
  } = useCartReturnUrl();
  if (isMobile) return <MobileHeader />;
  return <div className='layout-container relative z-10 flex items-center justify-between bg-white lg:h-[90px]' data-sentry-component="MainBar" data-sentry-source-file="main-bar.tsx">
            <div className='flex items-center gap-2 lg:gap-4'>
                <Logo data-sentry-element="Logo" data-sentry-source-file="main-bar.tsx" />
                {!isMobile && <SearchDesktop />}
            </div>
            <div className='flex w-full items-center gap-2 md:gap-3 lg:w-auto lg:justify-end lg:gap-5'>
                <UserProfile data-sentry-element="UserProfile" data-sentry-source-file="main-bar.tsx" />
                <AppNextLink href={OrderPagesURL.CART} prefetch={false} aria-label='Cart' onClick={setCartBackReturnUrl} className='flex items-center' data-sentry-element="AppNextLink" data-sentry-source-file="main-bar.tsx">
                    <CartCounterButton data-sentry-element="CartCounterButton" data-sentry-source-file="main-bar.tsx" />
                </AppNextLink>
            </div>
        </div>;
}
export default MainBar;